import React from 'react';
import ErrorsPerGrammarChart from './ErrorsPerGrammarChart';
import errorsPerGrammarChartService from '../../services/ErrorsPerGrammarChartService';
import { observer } from 'mobx-react';

function GlobalErrorsPerGrammarChartContainer() {
  return (
    <ErrorsPerGrammarChart
      data={errorsPerGrammarChartService.data}
      isFetching={errorsPerGrammarChartService.fetch.fetching}
    />
  );
}

export default observer(GlobalErrorsPerGrammarChartContainer);
